export default "__VITE_ASSET__C7MLsf1Z__"